export default __webpack_public_path__ + "static/hiblokcase1-7ade7e66e65579a8c432368d5cc70405.png";